import React, { useState } from "react";
import Box from "@mui/material/Box/Box";
import { Button, Checkbox, Grid } from "@mui/material";
import GenieText from "../../components/core/genie-text/GenieText";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate, useParams } from "react-router-dom";
import useAcceptInviteMetadata from "../../queries/routes/useAcceptInviteMetadata";
import GenieSpinner from "../../components/core/genie-spinner/GenieSpinner";
import GenieCanvas from "../../components/core/genie-canvas/GenieCanvas";
import useAcceptInvite from "../../queries/routes/useAcceptInvite";

function InviteBuyer() {
  const {
    loginWithRedirect,
    isAuthenticated,
    isLoading: isLoadingAuth,
  } = useAuth0();
  const navigate = useNavigate();
  const { invite_id } = useParams<{ invite_id: string }>();
  const {
    data: organization,
    isLoading,
    isError,
  } = useAcceptInviteMetadata(invite_id!);
  const { mutate: acceptInvite } = useAcceptInvite(invite_id!);
  const [formValues, setFormValues] = useState({
    name: "",
    terms: true,
    email: true,
  });

  if (isError) {
    navigate("/404");
  }

  if (isLoading || !organization || isLoadingAuth) {
    return <GenieSpinner />;
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setFormValues({
      ...formValues,
      [name]: checked,
    });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
  };

  return (
    <GenieCanvas imageUrl={`url("/assets/account.jpg")`}>
      <Box>
        <Box mr={1}>
          <Box display={"flex"} justifyContent={"space-between"}>
            <img
              height={"40px"}
              src={`/assets/genie_logo.svg`}
              alt={"Genie Logo"}
            />
            <img
              width={"40px"}
              height={"40px"}
              src={organization.image_set?.logo?.cloudinary_url || ""}
              alt={"Logo"}
            />
          </Box>
          <form onSubmit={handleSubmit}>
            <Box mt={2}>
              <Grid container>
                <Grid item xs={12}>
                  <GenieText>
                    Accept your invitation to {organization.name} on Genie
                  </GenieText>
                </Grid>
                <Grid item xs={12}>
                  <Grid item xs={12}>
                    <Box mb={2}>
                      <Box display={"flex"} alignItems={"flex-end"}>
                        <Checkbox
                          id="agree-terms"
                          name={"terms"}
                          value={formValues.terms}
                          defaultChecked
                          inputProps={{ "aria-label": "controlled" }}
                          onChange={handleCheckboxChange}
                        />
                        <GenieText subdued paragraph fontSize={"tiny"}>
                          By signing up, you agree to our Terms and privacy
                          policy.
                        </GenieText>
                      </Box>
                      <Box display={"flex"} alignItems={"flex-end"}>
                        <Checkbox
                          id="send-emails"
                          name={"email"}
                          value={formValues.email}
                          defaultChecked
                          inputProps={{ "aria-label": "controlled" }}
                          onChange={handleCheckboxChange}
                        />
                        <GenieText subdued fontSize={"tiny"}>
                          Yes, please send me transactional emails related to my
                          account. I understand that I can opt-out at anytime.
                        </GenieText>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Box mb={4}>
                    {!isAuthenticated ? (
                      <Button
                        variant={"outlined"}
                        size={"large"}
                        type={"submit"}
                        disabled={!formValues.terms}
                        fullWidth
                        onClick={() =>
                          loginWithRedirect({
                            redirectUri:
                              window.location.origin +
                              `/details-buyer?invite_id=${invite_id}&org_id=${
                                organization ? organization.id : "NA"
                              }`,
                            screen_hint: "signup",
                          })
                        }
                      >
                        Accept your Invitation to Genie
                      </Button>
                    ) : (
                      <Button
                        variant={"outlined"}
                        size={"large"}
                        onClick={() => {
                          acceptInvite(undefined, {
                            onSuccess: () => {
                              // Redirect to the storefront they were invited to
                              if (organization && organization.id) {
                                navigate(`/storefront/${organization.id}`);
                              } else {
                                // Fallback if organization data is missing
                                console.error("Organization data missing for redirect");
                                navigate("/");
                              }
                            },
                          });
                        }}
                      >
                        Join new store on Genie
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </form>
        </Box>
      </Box>
    </GenieCanvas>
  );
}

export default InviteBuyer;
